<template>
  <div class="product-recommendations critical-component-clear">
    <div class="product-recommendations__header">
      <h2
        class="
          product-recommendations__header-title
          text-desktop-regular-uc-desktop
          text-mobile-regular-uc-mobile
        "
        v-text="$string('product.recommendations.title')"
      />
    </div>

    <div class="product-recommendations__grid grid">
      <template
        v-for="(product, index) of products"
        :key="`product-recommendations-${index}`"
      >
        <product-card
          :product="product"
          :enable-quick-add="section.enableQuickAdd"
          :show-badge="section.showBadges"
          :show-flat-image="section.showFlatImages"
          class-name="product-card--medium product-recommendations-products__column col xs2 l4"
          data-gtm-event="recommended-products"
        />
      </template>
    </div>

    <secondary-product-data
      context="recommendation"
      :limit="section.productLimit"
      @products-updated="handleProductsUpdate"
    />
  </div>
</template>

<script>

/**
 * Vue: Product recommendations (product-recommendations)
 * -----------------------------------------------------------------------------
 * Section displaying product recommendations via Shopify's recommendation api.
 *
 * @param {Object} section - Section settings.
 *
 */
import { mapState } from 'vuex'

import ProductCard from '~async/product-card/product-card'
import SecondaryProductData from '~async/main-product/secondary-product-data'

export default {
  name: 'ProductRecommendations',

  components: {
    ProductCard,
    SecondaryProductData,
  },

  props: {
    section: {
      type: Object,
      default: () => ({
        enableQuickAdd: false,
        productLimit: 6,
        showBadges: false,
        showFlatImages: true,
      }),
    },
  },

  data() {
    return {
      products: [],
    }
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),
  },

  methods: {

    /**
     * Returns a value depending on the screen size.
     * The value indicates the position relative to the top of the viewport.
     * @returns {String}
     */
    checkSize() {
      return this.isMobile ? '120' : '160'
    },

    /**
     * Handles products being updated by the secondary product data component.
     * @param {Array} products - Array of product objects.
     */
    handleProductsUpdate(products) {
      if (!products) {
        this.products = []
        return
      }

      this.products = [...products]
    },
  },
}
</script>

<style lang="scss">
@import './product-recommendations';
</style>
